<template>
  <div id="user-top-mobile" class="hidden-lg hidden-md">
    <a href="/home" class="logo">
      <img src="https://static.phdvasia.com/my/logos/phnewlogo_horizontal.png"/>
    </a>
    <div class="box-right hidden-lg hidden-md">
      <!-- <router-link :to="{name: 'hut-rewards'}" hreflang="en-MY" class="flex-center padding-left-right-5">
        <span class="hut-rewards-logo"></span>
      </router-link> -->
      <div class="login-box" v-show="!isMobile()">
        <router-link to="/order" class="cart">
          <img src="../../assets/images/icons/cart.png" alt="Track Order" title="Track Order"
               class="img-cart">
          <span v-if="amount > 0" class="num-cart num-cart-mobile">
          {{amount}}
        </span>
        </router-link>
      </div>
      <!--<div class="login-box dropdown-lang" style="z-index: 990;">-->
        <!--<dropdown menu-right>-->
          <!--<btn class="dropdown-toggle">-->
            <!--<img v-for="item in langList"-->
                 <!--v-if="$const.LANGUAGES[item] && item == $i18n.locale"-->
                 <!--:src="$const.LANGUAGES[item]['image']"-->
                 <!--class="xs-mr-5"-->
                 <!--width='35'>-->
            <!--<span class="caret"></span>-->
          <!--</btn>-->
          <!--<template slot="dropdown">-->
            <!--<li v-for="item in langList">-->
              <!--<a v-if="$const.LANGUAGES[item]"-->
                 <!--role="button"-->
                 <!--@click="setLang(item)"-->
                 <!--class="decoration-none">-->
                <!--<img :src="$const.LANGUAGES[item]['image']"-->
                     <!--class="xs-mr-5" width="30">-->
                <!--{{ $const.LANGUAGES[item]['text'] }}-->
              <!--</a>-->
            <!--</li>-->
          <!--</template>-->
        <!--</dropdown>-->
      <!--</div>-->
      <div v-if="$auth.check()" class="login-box dropdown-lang" style="z-index: 990;">
        <router-link :to="{name: 'hut-rewards'}" hreflang="en-MY" style="margin-right: 10px">
          <span>{{(cart.customer_point != undefined ? cart.customer_point : ($auth.user().point ? $auth.user().point : 0))}}
            {{ $t("slices")}}
            <img style="max-width: 20px;" src="https://static.phdvasia.com/my/fcds/hutawards/pizza-icon.png">
          </span>
        </router-link>
        <dropdown menu-right>
          <btn class="dropdown-toggle dropdown-toggle-login">
            <img src="https://static.phdvasia.com/my/icons/active@2x.png" class="" width="25">
            <span class="caret"></span></btn>
          <template slot="dropdown">
            <li v-if="$auth.check()">
              <router-link style="background-color: #da291c; color: white;" to="">{{$t('full_name_format',
                {say_hi: 'HI!,',first_name:$auth.user().first_name})}}
              </router-link>
            </li>
            <li v-if="$auth.check()">
              <a v-on:click="logout">{{ $t("button_logout")}}</a>
            </li>
            <li v-if="$auth.check() && isMobile()">
              <router-link to="/profile">{{$t('update_your_profile')}}
              </router-link>
            </li>
            <li v-if="!$auth.check()">
              <router-link to="/login">{{ $t("login_title")}}</router-link>
            </li>
            <li v-if="!$auth.check()">
              <router-link to="/signup" hreflang="en-MY">{{ $t("login_register")}}</router-link>
            </li>
            <li>
              <router-link to="/tracking" hreflang="en-MY">{{ $t("track_your_order")}}</router-link>
            </li>
            <li>
              <router-link :to="{name: 'hut-rewards'}" hreflang="en-MY">{{ $t("hut_reward")}}</router-link>
            </li>

          </template>
        </dropdown>
      </div>
      <div v-else class="login-box dropdown-lang" style="z-index: 990;">
        <dropdown menu-right>
          <btn class="dropdown-toggle dropdown-toggle-login d-flex align-items-center">
            <!-- <img src="https://static.phdvasia.com/my/icons/inactive@2x.png" class="" width="25"> -->
            <strong class="mr-5">{{ $t("login_to") }}</strong>
            <span class="hut-rewards-logo mr-5" style="margin-top: 3px"></span>
            <span class="caret"></span>
          </btn>
          <template slot="dropdown">
            <li v-if="!$auth.check()">
              <div class="mobile-login-line">
                <img src="https://static.phdvasia.com/my/icons/inactive@2x.png" class="p-5">
                <router-link to="/login" hreflang="en-MY">{{ $t("login_title")}}</router-link>
              </div>
            </li>
            <li v-if="!$auth.check()">
              <div class="mobile-login-line">
                <img src="https://static.phdvasia.com/my/icons/inactive@2x.png" class="p-5">
                <router-link to="/signup" hreflang="en-MY">{{ $t("login_register")}}</router-link>
              </div>
            </li>
            <li>
              <router-link to="/tracking" hreflang="en-MY">{{ $t("track_your_order")}}</router-link>
            </li>
            <li>
              <router-link :to="{name: 'hut-rewards'}" hreflang="en-MY">{{ $t("hut_reward")}}</router-link>
            </li>

          </template>
        </dropdown>



        <!--<a href="/login">-->
          <!--<img src="https://static.phdvasia.com/my/icons/inactive@2x.png" class="" width="25">-->
        <!--</a>-->
      </div>
    </div>


    <!--<div v-on:click="toggleLogin" class="login-logo pull-right">
      <img v-if="!$auth.check()" src="https://static.phdvasia.com/jp/icons/inactive@2x.png" width="25">
      <img src="https://static.phdvasia.com/jp/icons/active@2x.png" class="" width="25" v-else>
      <span class="pl-10">
          <img src="https://static.phdvasia.com/my/fcds/icons/dropdown-black.png" width="10">
      </span>
    </div>
    <div class="login-box pull-right min-width-100" v-if="flag">
     &lt;!&ndash; <div class="clearfix pb2" v-if="flag"></div>&ndash;&gt;
      <div v-if="flag" class="item border-b line-h-30">
            <span v-if="$auth.check() ">
              {{$t('hello')}},  <router-link to="/profile">{{$auth.user().first_name}} {{$auth.user().last_name}}</router-link>
            </span>
        <router-link v-else to="/login">
          {{ $t("login_title") }}
        </router-link>
      </div>
<div class="item clearfix line-h-30" v-if="flag">
        <router-link to="/tracking">Track Order</router-link>
      </div>
      <div class="item clearfix border-b line-h-30" v-if="flag">
        <router-link to="/register" v-if="!$auth.check()">{{ $t("login_register")}}</router-link>
        <button v-else v-on:click="logout">{{ $t("button_logout")}}</button>
      </div>
    </div>-->
  </div>
</template>
<style scoped>
  .line-h-30 {
    line-height: 40px;
    padding-left: 10px;
  }

  .min-width-100 {
    min-width: 100px;
  }

  #user-top-mobile {
    position: absolute;
    right: 0;
    min-width: 80px;
    z-index: 1001;
  }

  .login-logo {
    text-align: center;
    /*line-height: 44px;*/
    width: 47px;
    margin: auto 10px auto auto;

  }

  .login-box {
    position: absolute;
    top: 44px;
    right: 0;
    width: 100px;
    line-height: 40px;
    background: #fff;
    /*padding: 0px 15px 0 0;*/
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 999;
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .15);
    padding-left: 0px;
  }

  .login-box a, .login-box span, .login-box button {
    text-decoration: none;
    color: #333;
    font-weight: 600;
  }
  .mobile-login-line{

  }
</style>
<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  export default {
    mounted: function () { this.$cart.init(this)
      var vm = this
      this.$root.$on('cartUpdate', () => {
        vm.$cart.init(vm)
        vm.amount = vm.getTotalCartItem(vm.cart)
      })
      vm.amount = this.getTotalCartItem(this.cart)
    },
    destroyed () {
      this.$root.$off('cartUpdate')
    },
    data() {
      return {
        flag: false,
        amount: 0,
        languages: this.$const.LANGUAGES
      }
    },
    computed: {
      ...mapGetters({
        langList: 'langList'
      }),
      layout() {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    },
    methods: {
      toggleLogin() {
        this.flag = !this.flag
      },
      logout: function () {
        this.$auth.logout({
          data: {
            token: this.$auth.user().token
          },
          success: function (response) {
            if (response.data.status) {
              this.$router.push('/')
            } else {
              main.$notify({
                type: 'Error',
                title: response.data.error.msg
              })
            }
          },
          error: function (data) {
            main.$notify({
              type: 'Error',
              title: this.$t('message_logout_error')
            })
          }
        })
      },
      changeLang(la) {
        this.lang = la
        this.$store.dispatch('setLang', la)
        this.$session.set('lang', la)
        this.$router.go(this.$router.currentRoute)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/home/HomeUserTopMobile.vue